var seriesSwitch = class {
    setListener(trigger) {
        let openClass = 'seriesSwitch_list-open';

        trigger.addEventListener('click', function (e) {
            if (!trigger.classList.contains(openClass)) {
                e.preventDefault();
            }

            trigger.classList.toggle(openClass);
        });

        window.addEventListener('click', function (e) {
            if (!e.target.classList.value.indexOf('seriesSwitch') <= 0) {
                trigger.classList.remove(openClass);
            }
        })

    }

    constructor(wrapper) {
        this.el = wrapper;
        let trigger = wrapper.querySelector('[data-seriesSwitchTrigger]');

        this.setListener(trigger);
    }
};

export default seriesSwitch;